import { render, staticRenderFns } from "./BowContentBlock.vue?vue&type=template&id=f586cfea&"
import script from "./BowContentBlock.vue?vue&type=script&lang=js&"
export * from "./BowContentBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BowHeading: require('/workspace/components/atoms/BowHeading/BowHeading.vue').default,BowAnimation: require('/workspace/components/base/BowAnimation/BowAnimation.vue').default,BowText: require('/workspace/components/atoms/BowText/BowText.vue').default,BowWrapper: require('/workspace/components/base/BowWrapper/BowWrapper.vue').default})
